module.exports = __webpack_public_path__ + "static/media/iconSearch.1efb7d82.png";